import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const SettingsYcpLazy = loadable(() => import(/* webpackChunkName: "SettingsLight" */ './SettingsYcp'));

export const SettingsYcpAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <SettingsYcpLazy />
    </DelayedSuspense>
);
